import './comp_marksheet_three.css'

const Comp_Marksheet_Three=(props)=>{
    return(

        <div class="mksheet-table-03">
    <div class="header mb-3">
        <h5>Appendix 6: Mark Sheet for DNS leading to B.Sc Applied Nautical Science</h5>
        <h5>STRUCTURED SHIPBOARD TRAINING PROGRAMME - SEMESTER III, IV and V - INTERNAL MARKS AWARDED</h5>
    </div>
    
    <div class="personal-info">
        <div>
            <strong>NAME OF THE TRAINING INSTITUTE:</strong><br/>
            <strong>CADET'S NAME:</strong><br/>
            <strong>DATE OF BIRTH:</strong><br/>
            <strong>EMAIL:</strong>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<strong>PHONE:</strong>
            
        </div>
        <div>
            <strong>GUNI ENROLMENT NO:</strong>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<strong>DATE:</strong><br/>
            <strong>PASSPORT NO:</strong> &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<strong>CDC NO:</strong><br/>
            <strong>SHIPPING COMPANY:</strong><br/>
            <strong>SEA SERVICE:</strong><br/>
        </div>
    </div>
    <h5> Total Summary of Marks and Credits</h5>
    <table class="marksheet">
        <thead>
            <tr>
                <th rowspan="2">Sr. No.</th>
                <th rowspan="2">Course Code</th>
                <th rowspan="2">Name</th>
                <th colspan="3">Progress</th>
                <th colspan="2">Total Marks</th>
                <th colspan="2">GUNI Exam</th>
                <th rowspan="2">Total Marks</th>
                <th rowspan="2">Total Factor</th>
                <th colspan="2">Grading</th>
                <th rowspan="2">Total</th>
                <th rowspan="2">Status</th>
                <th rowspan="2">Max</th>
                <th rowspan="2">Actual</th>
            </tr>
            <tr>
                <th>Max</th>
                <th>Actual</th>
                <th>Factor</th>
                <th>Total Marks</th>
                <th>Factor</th>
                <th>Max</th>
                <th>Actual</th>
                <th>Max</th>
                <th>Actual</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>1</td>
                <td></td>
                <td>Semester I Subject togehter</td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td>I</td>
                <td></td>
                <td>950</td>
                <td></td>
                <td>950</td>
                <td>18</td>
            </tr>
            <tr>
                <td>2</td>
                <td></td>
                <td>Semester II Subject togehter</td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td>II</td>
                <td></td>
                <td>750</td>
                <td></td>
                <td>750</td>
                <td>18</td>
            </tr>
            <tr>
                <td>3</td>
                <td>T1301</td>
                <td>Navigation</td>
                <td></td>
                <td>200</td>
                <td></td>
                <td>180</td>
                <td></td>
                <td>620</td>
                <td></td>
                <td></td>
                <td>400</td>
                <td>III</td>
                <td></td>
                <td>200</td>
                <td></td>
                <td>600</td>
                <td>12</td>
            </tr>
            <tr>
                <td>4</td>
                <td>T1401</td>
                <td>Cargo Handling and Stowage</td>
                <td></td>
                <td>70</td>
                <td></td>
                <td>550</td>
                <td></td>
                <td>90</td>
                <td></td>
                <td></td>
                <td>400</td>
                <td>IV</td>
                <td></td>
                <td>200</td>
                <td></td>
                <td>600</td>
                <td>11</td>
            </tr>
            <tr>
                <td>5</td>
                <td>CRB Section 9</td>
                <td>Watch keeping</td>
                <td></td>
                <td>290</td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>6</td>
                <td>T1501</td>
                <td>Controlling the operation of ship and Care for persons on board</td>
                <td></td>
                <td>200</td>
                <td></td>
                <td>350</td>
                <td></td>
                <td>190</td>
                <td></td>
                <td></td>
                <td>400</td>
                <td>V</td>
                <td></td>
                <td>200</td>
                <td></td>
                <td>600</td>
                <td>11</td>
            </tr>
            <tr>
                <td>7</td>
                <td>CRB Section 5,6,7</td>
                <td>Safety Familiarisation and COLREGS</td>
                <td></td>
                <td>260</td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>8</td>
                <td></td>
                <td>Second Mates Exam Written</td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td>VI</td>
                <td></td>
                <td></td>
                <td></td>
                <td>1200</td>
                <td>21</td>
            </tr>
            <tr>
                <td>9</td>
                <td></td>
                <td>Second Mates Exam Orals</td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td class="cancelled"></td>
                <td>VI</td>
                <td></td>
                <td></td>
                <td></td>
                <td>300</td>
                <td>9</td>
            </tr>
           
            <tr>
                <td></td>
                <td></td>
                <th>TOTAL</th>
                <td></td>
                <th>1020</th>
                <td></td>
                <th>1080</th>
                <td></td>
                <th>900</th>
                <td></td>
                <td></td>
                <th>1200</th>
                <td></td>
                <td></td>
                <th>2300</th>
                <td></td>
                <th>5000</th>
                <th>100</th>
            </tr>
        </tbody>
    </table>

    <div class="signature-section">
        <div class="signature-block">
           <strong> SSTP OFFICER NAME AND SIGNATURE</strong>
        </div>
        <div class="signature-block">
        <strong> PRE -SEA INSTITUTE STAMP</strong>
        </div>
        <div class="signature-block">
        <strong>  PRINCIPAL - PRE-SEA INSTITUTE- NAME AND SIGNATURE</strong>
        </div>
    </div>
   </div>
    );
}

export default Comp_Marksheet_Three